/** Public BSC RPCs refuse an eth_getLogs over more than 50,000 blocks; stay under it with room to spare. */
export const LOG_RANGE = 45_000n;

/**
 * Logs from `fromBlock` to the head, fetched in windows of at most `step` blocks (oldest first), so a query over a
 * deployment's whole life keeps working as the chain grows past the RPC's range limit.
 */
export async function pagedLogs<T>(
  head: bigint,
  fromBlock: bigint,
  fetch: (fromBlock: bigint, toBlock: bigint) => Promise<T[]>,
  step = LOG_RANGE,
): Promise<T[]> {
  const windows: [bigint, bigint][] = [];
  for (let from = fromBlock; from <= head; from += step) windows.push([from, from + step - 1n < head ? from + step - 1n : head]);
  const out: T[] = [];
  for (let i = 0; i < windows.length; i += 4) {
    const batch = await Promise.all(windows.slice(i, i + 4).map(([a, b]) => fetch(a, b))); // four at a time: kind to a public RPC
    for (const logs of batch) out.push(...logs);
  }
  return out;
}
